import { call, put } from 'redux-saga/effects';

import { creators as PManagementActions } from '../../Reducers/PManagement';
import Api from '../../Api/DefaultApi';

export function* getPackageSettings() {
  try {
    const response = yield call(Api.getPackageSettings, null);
    if (response.status === 200) {
      yield put(
        PManagementActions.pmanagementSuccess({ packageSettings: response.data }),
      );
    } else {
      yield put(PManagementActions.pmanagementFailure(response.message));
    }
  } catch (e) {
    yield put(PManagementActions.pmanagementFailure(e));
  }
}
